export enum CustomTableFunctionTypeEnum {
  LINK = 'link',
  STATUS_BAR = 'status_bar',
  BUTTON = 'button',
}
